import { BuildingType } from "../building-type"

export class RoofType {
  id: number
  name: string
  iconUrl: string
  premiseType: BuildingType

  constructor({id, name, iconUrl, premiseType }: RoofType) {
      this.id = id
      this.name = name
      this.iconUrl = iconUrl
      this.premiseType = premiseType
  }
}